/**
 * @capability-ng-scheduler
 */
import * as _4 from 'lodash4';
require('./vendor');

angular.module('capability-ng-scheduler', [
  'ui.router',
  'ui-ng-draggable',
  'ui-ng-dropdown',
  'ui-ng-sibling',
  'ui-ng-modal',
  'ui-ng-calendar',
  'ui-ng-calendar-time',
  'utility-ng-interface',
  'utility-ng-configuration',
  'utility-ng-enumeration',
  'utility-ng-auth-token',
  'data-ng-authentication',
  'data-ng-custom-text',
  'ui-ng-component-communicator',
  'biz-ng-requisite-tree',
  'ng-screen-query'
]);
require('./core');
require('./modules');

export * from './config/state_configuration';
export * from './config/calendar_configuration';
export * from './search_and_add_courses/facades/search_and_courses_feature_facade';
export * from './standalone_scheduler/queries/standalone_scheduler_details_query';
export * from './standalone_scheduler/commands/clear_standalone_scheduler_info_command';
export * from './standalone_scheduler/commands/navigate_to_scheduler_command';
export * from './interfaces/scheduler_interfaces';

export const scheduler = 'capability-ng-scheduler';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/main.ts